import { CHART_SHADOW, MONTHS } from "lib/constants";
import { FC } from "react";
import ReactApexChart from "react-apexcharts";

interface GroupedBarChartProps {
  data: ReportData;
  width?: string | number;
  height?: string | number;
  className?: string;
}

const GroupedBarChart: FC<GroupedBarChartProps> = ({
  data,
  width,
  height,
  className,
}) => {
  const categories: string[] = MONTHS;

  const series = [
    {
      data: data.data,
    },
  ];

  const color = ["black"];

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      stacked: false,
      stackType: "normal",
      toolbar: { show: false },
      redrawOnParentResize: true,
      foreColor: "#999",
      dropShadow: CHART_SHADOW
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 3,
        borderRadiusApplication: "end",
        dataLabels: {
          position: "top"
        }
      },
    },
    colors: color,
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val + "%";
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        fontFamily: 'quicksand',
        colors: ["#304758"]
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories,
      title: { text: "Month" },
      labels: { style: { fontSize: "14px" } },
    },
    yaxis: {
      max:100,
      title: { text: "Retention (%)" },
      labels: { show: true },
    },
    grid: {
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    legend: {
      show: true,
      position: "top",
    },
    fill: { opacity: 1 },
    tooltip: {
      enabled: true,
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const label = w.globals.labels?.[dataPointIndex] ?? "N/A";
        const value = series?.[seriesIndex]?.[dataPointIndex];

        const formatted =
          typeof value === "number" && !isNaN(value)
            ? `${value.toFixed(1)}%`
            : "No data";

        return `<div class="arrow_box">
          <div>${label} — ${formatted}</div>
        </div>`;
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={height ?? "100%"}
      width={width ?? "100%"}
      className={className}
    />
  );
};

export default GroupedBarChart;
